import {
  customFieldFetchRequest,
  customFieldFetchRequestSuccess,
  customFieldFetchRequestFailure,
} from './actions';
import { fetch, store } from '../../../utils/httpUtil';

export const fetchCustomField = (formData) => {
  return (dispatch) => {
    dispatch(customFieldFetchRequest());
    return store('custom-fields/v1/custom-fields/public/list', formData)
      .then((response) => {
        if (response.data.message === 'SUCCESS') {
          dispatch(customFieldFetchRequestSuccess(response.data.data));
        } else {
          // TODO
        }
      })
      .catch((error) =>
        dispatch(customFieldFetchRequestFailure(error.response.data))
      );
  };
};

export const fetchCustomFieldByIdentifier = (identifier) => {
  return (dispatch) => {
    dispatch(customFieldFetchRequest());
    return fetch(`custom-fields/v1/custom-fields/${identifier}`)
      .then((response) => {
        if (response.data.message === 'SUCCESS') {
          dispatch(customFieldFetchRequestSuccess(response.data.data));
        } else {
          // TODO
        }
      })
      .catch((error) =>
        dispatch(customFieldFetchRequestFailure(error.response.data))
      );
  };
};
